// components/ui/Button.jsx
import React, { useState } from 'react';
import { Icon } from './Icon';
import { useBrand } from '../../contexts/BrandContext';

export function Button({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  icon, 
  onClick, 
  disabled, 
  fullWidth,
  style = {}
}) {
  const { brand } = useBrand();
  const [hover, setHover] = useState(false);
  
  const sizes = {
    sm: { padding: '7px 16px', fontSize: 12, borderRadius: 6 },
    md: { padding: '12px 24px', fontSize: 14, borderRadius: 8 },
    lg: { padding: '16px 32px', fontSize: 15, borderRadius: 8 }
  };
  
  const variants = {
    primary: { 
      background: hover ? brand.c.navyMid : brand.c.navy, 
      color: '#fff' 
    },
    accent: { 
      background: hover ? brand.c.accentDark : brand.c.accent, 
      color: '#fff' 
    },
    secondary: { 
      background: hover ? brand.c.blueLight : 'transparent', 
      color: brand.c.navy, 
      border: `2px solid ${brand.c.navy}` 
    },
    ghost: { 
      background: hover ? brand.c.blueLight : 'transparent', 
      color: brand.c.blue 
    },
    gold: { 
      background: hover ? '#D4B76A' : brand.c.gold, 
      color: brand.c.navy 
    },
    danger: { 
      background: hover ? '#DC2626' : '#EF4444', 
      color: '#fff' 
    }
  };
  
  const sizeStyle = sizes[size];
  const variantStyle = variants[variant];
  
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontWeight: 700,
        transition: 'all 0.2s',
        width: fullWidth ? '100%' : 'auto',
        opacity: disabled ? 0.5 : 1,
        fontFamily: 'Libre Franklin, sans-serif',
        ...sizeStyle,
        ...variantStyle,
        ...style
      }}
    >
      {icon && <Icon name={icon} size={sizeStyle.fontSize + 2} />}
      {children}
    </button>
  );
}